import z from 'zod';

export const schema = z.object({
  pin: z
    .string()
    .trim()
    .min(1, { error: 'AddEquipment.MachinePinError' })
    .max(40, { error: 'maximum_length_exceeded' }),
  model: z
    .string()
    .trim()
    .min(3, { error: 'AddEquipment.MachineModelError' })
    .max(40, { error: 'maximum_length_exceeded' }),
});

export type FormData = z.infer<typeof schema>;
